export const menuItems = [
    {
        id: 1,
        label: 'menuitems.dashboards.text',
        icon: 'bx-home-circle',
        link: '/'
    },
    {
        id: 2,
        label: "menuitems.users.text",
        icon: "bx-user-circle",
        link: "/users"
    },
    {
        id: 3,
        label: "menuitems.news.text",
        icon: "bx-archive",
        link: "/news"
    }
];

